{
  "pr_fam_100514": "000107",
  "pr_fam_321808": "000127",
  "pr_fam_100506": "000109",
  "pr_fam_255260": "000328",
  "pr_fam_100507": "000111",
  "pr_fam_257781": "000141",
  "pr_fam_100511": "007574",
  "pr_fam_100513": "441103",
  "pr_fam_100512": "441101",
  "pr_fam_100510": "000115",
  "pr_fam_100509": "000117",
  "pr_fam_100516": "000113",
  "pr_fam_109739": "000113",
  "pr_fam_101884": "002862",
  "pr_fam4135194": "000252"
}
